import React from 'react';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { IndicatorProps } from 'react-select';
import classNames from 'classnames';

import { Icon } from '../../icon';
import { InputClassProps } from '../../input-class-name.util';
import { Option } from '../option.model';

export const DropdownIndicator = ({
  innerProps,
  isFocused,
  height = 'md',
  isDisabled,
}: IndicatorProps<Option, true> & InputClassProps) => {
  return (
    <div
      {...innerProps}
      className={classNames('text-primary-500', {
        'px-4 py-3': height === 'md',
        'px-2 py-1': height === 'sm',
      })}
    >
      <Icon
        className={classNames({
          'text-primary-300': isDisabled,
        })}
        icon={isFocused ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
      />
    </div>
  );
};
